import { FeatureToggleClientService } from 'feature-toggle-client';
const showSmartSalesMenu = 'bcom-show-smart-sales-in-menu';
export class SmartSalesFeatures {
    static IsSmartSalesEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(showSmartSalesMenu, false);
    }
}
